
import React, {useState, useRef, useEffect} from 'react';

import { v4 as uuidv4 } from 'uuid';


const NewSetlistModal = ({isOpen, clientConfiguration, title, setTitle, subtitle, setSubtitle, imageUrl, setImageUrl, firstSetlist, setUserInputtingText}) => {

  const [progress , setProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const uploadInput = useRef(null);

  useEffect(()=>{
    if (!isOpen) {

      setUserInputtingText(false);
      setProgress(0);
      setSelectedFile(null);
      setImageUrl(clientConfiguration.features.setlist.defaultSetlistImageUrl)
    } else {
      setUserInputtingText(true);
    }
  },[isOpen]);

  const handleFileInput = (e) => {
      setSelectedFile(e.target.files[0]);
      handleUpload(e.target.files[0]);
  }

  const handleUpload = async (file) => {  
    const response = await fetch("https://c5lkyhqqql.execute-api.eu-west-1.amazonaws.com/default/uploadChoirPlayerImages");
    const responseParsed = await response.json();

    const s3Result = await fetch(responseParsed.uploadURL, {
      method: "PUT",
      body: file,
    });

    
    setImageUrl(`https://s3.eu-west-1.amazonaws.com/uploads.choirplayer.com/${responseParsed.filename}`);
    setSelectedFile(null)
    return `https://s3.eu-west-1.amazonaws.com/uploads.choirplayer.com/${responseParsed.filename}`
  };  


    return <form className="space-y-8 divide-y divide-gray-200 w-full grow">
    <div className="space-y-8 divide-y divide-gray-200 sm:space-y-5">
      <div>
          {firstSetlist && <p className="mt-1 max-w-2xl text-sm text-gray-500">
            You currently have no setlists, please create one below.
          </p>}
        <div className="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
              Title
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2">
              <div className="max-w-lg flex rounded-md shadow-sm">
                <input
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                    type="text"
                    name="title"
                    id="title"
                    autoComplete="off"
                    className="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-md sm:text-sm border-gray-300"
                />
              </div>
            </div>
          </div>

          <div className="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
              Subtitle
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2">
              <div className="max-w-lg flex rounded-md shadow-sm">
                
                <input
                    value={subtitle}
                    onChange={(e)=>setSubtitle(e.target.value)}
                    type="text"
                    name="subtitle"
                    id="subtitle"
                    autoComplete="off"
                    className="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-md sm:text-sm border-gray-300"
                />
              </div>
            </div>
          </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center sm:border-t sm:border-gray-200 sm:pt-5">

			{/*
			  pgw 19-jul-2025
			  <label htmlFor="photo" className="block text-sm font-medium text-gray-700">
				Thumbnail
			  </label>
			*/}

            <div className="mt-1 sm:mt-0 sm:col-span-2">
              <div className="flex items-center">
                <span className="h-40 w-40 rounded-md overflow-hidden bg-gray-100">
                  <img alt="Setlist thumbnail" className="object-cover h-full w-full text-gray-300" src={imageUrl}/>
                </span>
                <input
                type="file"
                ref={uploadInput}
                accept="image/png, image/gif, image/jpeg"
                onChange={handleFileInput}
                className="hidden ml-4 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50"
              />

				{/*
				  pgw 19-jul-2025
				  <button
					onClick={(e)=>{
					  if (!selectedFile) {
						e.preventDefault();
						uploadInput.current.click();
					  }
					}}
					type="button"
					className="ml-4 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50"
				  >
					{selectedFile ? `Uploading...` : 'Upload thumbnail'}
				  </button>
				*/}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
}

export default NewSetlistModal